"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GridList_1 = require("@material-ui/core/GridList");

var React = require("react");

var _1 = require("./");

exports.MobileDataGridTable = function (_a) {
  var grid = _a.grid,
      onRowClick = _a.onRowClick;
  return React.createElement(GridList_1["default"], {
    cellHeight: 'auto',
    cols: 1
  }, grid.state.data.map(function (row, index) {
    return React.createElement(_1.DataGridCard, {
      columns: grid.state.columns,
      item: row,
      onClickCallback: onRowClick,
      key: index
    });
  }));
};